/* ============================================================================
   §5.3 · Sticky bottom bar.
   Appears once the buy box scrolls out of view; persists to the footer.
   Mirrors the buy box's plan selection — never holds its own.
   ========================================================================= */
(function () {
  'use strict';

  var bar = document.querySelector('[data-sticky-bar]');
  var buyBox = document.querySelector('[data-buy-box]');
  if (!bar || !buyBox) return;

  var chipHost = bar.querySelector('[data-sticky-plans]');
  var footer = document.querySelector('.shopify-section-group-footer-group, footer');

  /* --- Build chips from the real radios ---------------------------------- */

  var radios = Array.prototype.slice.call(buyBox.querySelectorAll('[data-plan]'));

  var chips = radios.map(function (radio) {
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 's-stickychip';
    chip.textContent = radio.getAttribute('data-label') || 'Plan';
    // Selecting from here changes the buy box, which then re-renders this bar.
    // One source of truth, always.
    chip.addEventListener('click', function () {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
    });
    chipHost.appendChild(chip);
    return { chip: chip, radio: radio };
  });

  function sync() {
    chips.forEach(function (c) {
      var on = c.radio.checked;
      c.chip.classList.toggle('is-on', on);
      c.chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  buyBox.addEventListener('change', sync);
  sync();

  /* --- Reveal ------------------------------------------------------------ */

  // Shown when the buy box is above the viewport, hidden again once the footer
  // arrives so the bar never covers the footer's own links.
  var buyBoxPassed = false;
  var footerReached = false;

  function apply() {
    var show = buyBoxPassed && !footerReached;
    if (show === !bar.hidden) return;
    bar.hidden = !show;
    // Toggle the animation class on the next frame; setting `hidden` and the
    // transform in the same frame gives the browser nothing to animate from.
    if (show) requestAnimationFrame(function () { bar.classList.add('is-up'); });
    else bar.classList.remove('is-up');
  }

  if (!('IntersectionObserver' in window)) return;

  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      // Passed = out of view AND scrolled above the viewport, so the bar does
      // not appear while the visitor is still above the buy box on load.
      buyBoxPassed = !e.isIntersecting && e.boundingClientRect.top < 0;
      apply();
    });
  }, { threshold: 0 }).observe(buyBox);

  if (footer) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        footerReached = e.isIntersecting;
        apply();
      });
    }, { threshold: 0 }).observe(footer);
  }
})();
